import { defineMessages } from 'react-intl';

export default defineMessages({
	migrationAnnouncementBase: {
		defaultMessage: 'Your help centers are getting an update.',
		description:
			'Base announcement shown above Help Center management when migration is available.',
		id: 'help.center.management.page.migration.announcement.base',
	},
	migrationAnnouncementDueDate: {
		defaultMessage: 'Update now or test it out before {dueDate, date, medium}.',
		description: 'Migration announcement deadline, formatted in the viewer’s locale.',
		id: 'help.center.management.page.migration.announcement.due-date',
	},
	migrationAnnouncementLearnMore: {
		defaultMessage: 'Learn more.',
		description: 'Link label leading to more information about the Help Center migration.',
		id: 'help.center.management.page.migration.announcement.learn-more',
	},
	migrationHeaderText: {
		defaultMessage: 'Update help centers',
		description:
			'Help Center management screen header text when help center migration is available.',
		id: 'help.center.management.page.migration.header.text',
	},
	migrationHeaderDescription: {
		defaultMessage: 'Manage your help centers and update them here.',
		description:
			'Help Center management screen header description when help center migration is available.',
		id: 'help.center.management.page.migration.header.description',
	},
	migrationUpdateButton: {
		defaultMessage: 'Update',
		description: 'Button that starts the Help Center update flow from the management page header.',
		id: 'help.center.management.page.migration.update.button',
	},
	headerTextHelpCenter: {
		defaultMessage: 'Help centers',
		description: 'Help centers management screen header text',
		id: 'help.center.management.page.header.text',
	},
	headerTextHelpHub: {
		defaultMessage: 'Help centers',
		description: 'Help centers management screen header text hubs',
		id: 'help.center.management.page.header.text.hubs',
	},
	headerDescriptionHelpCenter: {
		defaultMessage: 'Set up and manage your help centers here.',
		description: 'Help centers management screen header description',
		id: 'help.center.management.page.header.description',
	},
	headerDescriptionReadMoreLinkHelpCenter: {
		defaultMessage: 'Read more about help centers',
		description: 'Help centers management screen header description read more link',
		id: 'help.center.management.page.header.description.read.more.link',
	},
	headerDescriptionHelpHub: {
		defaultMessage: 'Set up and manage your help centers here.',
		description: 'Help centers management screen header description',
		id: 'help.center.management.page.header.description.hubs',
	},
	addButtonTextHelpCenter: {
		defaultMessage: 'Create help center',
		description: 'Help centers management screen add help center button text',
		id: 'help.center.management.add.help.center.button.text',
	},
	addButtonTextHelpHub: {
		defaultMessage: 'Create help center',
		description: 'Help centers management screen create button text',
		id: 'help.center.management.create.button.text.hubs',
	},
	createOptionHelpCenterTitle: {
		defaultMessage: 'Help center',
		description: 'Help centers management screen create option help center title',
		id: 'help.center.management.create.option.help.center.title',
	},
	createOptionHelpCenterDescription: {
		defaultMessage: 'The default help experience with portals, topics, and more',
		description: 'Help centers management screen create option help center description',
		id: 'help.center.management.create.option.help.center.description',
	},
	createOptionHubTitle: {
		defaultMessage: 'Help center',
		description: 'Help centers management screen create option hub title',
		id: 'help.center.management.create.option.hub.title',
	},
	createOptionHubDescription: {
		defaultMessage: 'Create a modern help experience with components and customization',
		description: 'Help centers management screen create option hub description',
		id: 'help.center.management.create.option.hub.description',
	},
	genericErrorHeading: {
		defaultMessage: 'Something bad happened',
		description: 'Generic error when something could not be loaded',
		id: 'help.center.management.page.generic.error.heading',
	},
	genericErrorMessage: {
		defaultMessage:
			'Looks like we’re having trouble retrieving some information, please refresh the page.',
		description: 'Generic error when something could not be loaded',
		id: 'help.center.management.page.generic.error.message',
	},
	authPageMessage: {
		defaultMessage: `You don't have permission to view this page.`,
		description: 'Message text for unauthorized page of portal reordering',
		id: 'help.center.management.page.un.auth.action.message',
	},
	callToActionUrlText: {
		defaultMessage: 'Go to help center',
		description: 'Call to action text for unauthorized page of portal reordering',
		id: 'help.center.management.page.un.auth.action.text',
	},
	upgradeTitleCreateClick: {
		defaultMessage: 'Upgrade to create new help centers',
		description: 'Popup title to upgrade to create help center',
		id: 'help.center.management.upgrade.title.create.click',
	},
	upgradeDescriptionCreateClick: {
		defaultMessage:
			'You need to be on a Premium or Enterprise plan to create multiple help centers on your site.',
		description: 'Popup description to upgrade to create help center',
		id: 'help.center.management.upgrade.description.create.click',
	},
	helpHubEmptyStateHeader: {
		defaultMessage: 'Create modern help centers to serve your customers',
		description: 'Help center empty state header',
		id: 'help.center.management.page.help.hub.empty.state.header',
	},
	helpHubEmptyStateDescription: {
		defaultMessage:
			'Empower customers to find answers with knowledge base articles or get support by raising requests in Jira Service Management.',
		description: 'Help center empty state description',
		id: 'help.center.management.page.help.hub.empty.state.description',
	},
	jiraSidebarHelpCenterExperimentTitle: {
		defaultMessage: 'Your new help centers have moved to the Jira Service Management app',
		description:
			'Title of an experimental message on Help Center management that directs customers to the new management experience.',
		id: 'help.center.management.page.jira.sidebar.helpcenter.experiment.title',
	},
	jiraSidebarHelpCenterExperimentAction: {
		defaultMessage: 'View new help centers',
		description:
			'Link in the experimental Help Center management message that opens the new Jira Service Management help centers page.',
		id: 'help.center.management.page.jira.sidebar.helpcenter.experiment.action',
	},
	jiraSidebarHelpCenterExperimentBeta: {
		defaultMessage: 'Beta',
		description:
			'Lozenge label next to the experimental Help Center management link indicating that the destination is in beta.',
		id: 'help.center.management.page.jira.sidebar.helpcenter.experiment.beta',
	},
	jiraSidebarHelpCenterExperimentDescription: {
		defaultMessage:
			'All new help centers can now be created and managed from within the main app navigation.',
		description:
			'Description in an experimental Help Center management message explaining where customers can create and manage new help centers.',
		id: 'help.center.management.page.jira.sidebar.helpcenter.experiment.description',
	},
});
